window.createShopApp = function(config) {
  var allowedVehicleCodes = config.allowedVehicleCodes || [config.defaultVehicleCode];

  return new Vue({
    el: config.mountSelector,
    delimiters: ['${', '}'],
    data: function() {
      return {
        isFetched: false,
        isFetching: false,
        shop_list: [],
        val_item: config.defaultVehicleCode || allowedVehicleCodes[0] || '',
        allowedVehicleCodes: allowedVehicleCodes
      };
    },
    computed: {
      hasAllowedCodes: function() {
        return this.allowedVehicleCodes && this.allowedVehicleCodes.length > 0;
      },
      filteredShopList: function() {
        if (!this.isFetched) return [];
        if (!this.hasAllowedCodes) return [];

        var selectedCode = String(this.val_item).trim();
        return this.shop_list.filter(function(shop) {
          var types = shop.test_vehicle_types || [];
          return types.length > 0;
        });
      }
    },
    methods: {
      addPrefectureData: function(data) {
        var address = data.address_name || '';
        var match = address.match(/(...??[都道府県])((?:旭川|伊達|石狩|盛岡|奥州|田村|南相馬|那須塩原|東村山|武蔵村山|羽村|十日町|上越|富山|野々市|大町|蒲郡|四日市|姫路|大和郡山|廿日市|下松|岩国|田川|大村)市|.+?郡(?:玉村|大町|.+?)[町村]|.+?市.+?区|.+?[市区町村])(.+)/);

        if (match) {
          this.$set(data, 'pref', match[1] || null);
          this.$set(data, 'city', match[2] || null);
        } else {
          this.$set(data, 'pref', null);
          this.$set(data, 'city', null);
        }
      },
      addHolidayData: function(data) {
        var texts = (((data || {}).details || [])[0] || {}).texts || [];
        var holiday = texts.find(function(item) {
          return item.label === '定休日';
        });
        this.$set(data, 'holiday', holiday && holiday.value ? holiday.value : null);
      },
      addVehicleTypes: function(data) {
        var _this = this;
        var flags = (((data || {}).details || [])[0] || {}).flags || [];
        var hits = flags.filter(function(item) {
          var itemCode = String(item.code).trim();
          var isEnabled = item.value === true || item.value === 'true' || item.value === 1;
          return _this.allowedVehicleCodes.includes(itemCode) && isEnabled;
        });
        this.$set(data, 'test_vehicle_types', hits);
      },
      normalizeShop: function(data) {
        this.addPrefectureData(data);
        this.addHolidayData(data);
        this.addVehicleTypes(data);
        this.$set(data, 'link', 'https://pkg.navitime.co.jp/bridgestone-cycle/spot/detail?code=' + data.code + '&mv=00186&dc=%7B%22c_d186%22%3A1%7D');
        this.$set(data, 'isActive', false);
        return data;
      },
      fetchShops: function() {
        var _this = this;
        if (_this.isFetched || _this.isFetching) return;
        _this.isFetching = true;

        $.ajax({
          url: config.shopUrl,
          type: 'GET',
          dataType: 'jsonp',
          jsonpCallback: config.jsonpCallback || 'parseJson',
          cache: true
        }).then(function(response) {
          _this.shop_list = (response.items || []).map(function(item) {
            return _this.normalizeShop(item);
          });
          _this.isFetched = true;
        }).always(function() {
          _this.isFetching = false;
        });
      }
    }
  });
};
